import React from "react";
import { Transition } from "@headlessui/react";
import { MerchantButton } from "@components";
import { formatAmount } from "@utils";
import { TagIcon } from "@heroicons/react/16/solid";

const SummaryButton = ({
  errorMessage,
  currentAmount,
  handleContinue,
  processing,
  adyenLoading,
  disabled,
  merchant,
  hasStatement,
  summaryData,
  settlementDiscount = 0,
  klarnaEmailAddressConfirmed,
}) => {
  const invoiceDisplayAmount = currentAmount
    ? currentAmount.baseAmount + settlementDiscount
    : null;
  return (
    <>
      {!!errorMessage ? (
        <div className="flex items-center gap-2">
          <div className="flex-shrink-0 w-5 h-5 mt-0.5">
            <div className="w-5 h-5 border-red-600 border rounded-full flex items-center justify-center">
              <span className="text-red-600 text-sm font-bold">!</span>
            </div>
          </div>
          <div className="text-red-600 text-xs/5">{errorMessage}</div>
        </div>
      ) : (
        <>
          <Transition
            show={!!currentAmount}
            appear
            enter="transition-opacity duration-300 ease-in"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition-opacity duration-300 ease-in"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="py-2 lg:py-0">
              <div className="flex justify-between items-center mb-2 lg:mb-3">
                {hasStatement ? (
                  <span className="text-zinc-600 font-light text-sm">
                    {summaryData?.invoiceCount}{" "}
                    {summaryData?.invoiceCount !== 1 ? "invoices" : "invoice"}
                  </span>
                ) : (
                  <span className="text-zinc-600 font-light text-sm">
                    Amount
                  </span>
                )}
                <span className="font-normal lg:font-light text-sm">
                  {invoiceDisplayAmount != null && formatAmount(invoiceDisplayAmount)}
                </span>
              </div>
              {settlementDiscount !== 0 && (
                <div className="flex justify-between items-center mb-2 lg:mb-3">
                  <span className="text-zinc-600 font-light text-sm flex items-center gap-1">
                    <TagIcon className="size-3.5 shrink-0" />
                    Settlement discount
                  </span>
                  <span className={`font-light text-sm ${settlementDiscount > 0 ? "text-green-700" : "text-zinc-600"}`}>
                    {settlementDiscount > 0 ? "-" : "+"}{formatAmount(Math.abs(settlementDiscount))}
                  </span>
                </div>
              )}
              {/* "You will pay" section - only show on lg: screens */}
              <div className="hidden lg:flex justify-between items-center py-2.5 lg:py-4 font-normal border-t border-zinc-600">
                <span>You will pay</span>
                <span>
                  {currentAmount && formatAmount(currentAmount.baseAmount)}
                </span>
              </div>
            </div>
          </Transition>
        </>
      )}
      {klarnaEmailAddressConfirmed && (
        <MerchantButton
          onClick={handleContinue}
          disabled={disabled}
          loading={(processing || adyenLoading) && klarnaEmailAddressConfirmed}
          merchant={merchant}
          className="w-full"
        >
          Continue to Klarna
        </MerchantButton>
      )}
    </>
  );
};

export default SummaryButton;
